import styled from 'styled-components';

const Wrapper = styled.header`
  display: block;
  padding: 14px 20px 10px;
  background: transparent;
  border-bottom: 0;
  box-shadow: none;
  position: relative;

  @media (min-width: 768px) {
    padding: 18px 24px 12px;
  }
`;

const WrapperContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 18px;
  margin: 0 auto;
  max-width: 1120px;
  position: relative;
  width: 100%;
`;

const PoweredBy = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-width: 168px;
`;

const PoweredByText = styled.span`
  color: #64748b;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`;

const PoweredByLogo = styled.div`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;

  img {
    width: 90px;
    height: auto;
    display: block;
  }
`;

export { Wrapper, WrapperContainer, PoweredBy, PoweredByText, PoweredByLogo };
